import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../../../../helpers/custom-prop-types';
import Image from '../../../../../../Ui/Common/Image';
const ShareTableRowImage = (props) => {
    const { members } = props;
    if (members.length > 1) {
        return (_jsxs("div", Object.assign({ className: 'user_col_thumbnail user_col_multi_thumbnail_box' }, { children: [_jsx("div", Object.assign({ className: 'user_col_multi_thumbnail user_col_thumbnail_circle' }, { children: _jsx(Image, { alt: '', isGrayScale: true, isObjectFit: true, noImageType: 'user', src: members[0].photo, useImage: true }) })), _jsx("div", Object.assign({ className: 'user_col_multi_thumbnail user_col_thumbnail_circle' }, { children: _jsx(Image, { alt: '', isGrayScale: true, isObjectFit: true, noImageType: 'user', src: members[1].photo, useImage: true }) }))] })));
    }
    return (_jsx("div", Object.assign({ className: 'user_col_thumbnail user_col_thumbnail_circle' }, { children: _jsx(Image, { alt: '', isGrayScale: true, isObjectFit: true, noImageType: 'user', src: members[0].photo, useImage: true }) })));
};
ShareTableRowImage.propTypes = {
    members: propArrayShape().isRequired,
};
export default ShareTableRowImage;
